import { render, staticRenderFns } from "./privacySDK.vue?vue&type=template&id=fdbc411a&"
import script from "./privacySDK.vue?vue&type=script&lang=js&"
export * from "./privacySDK.vue?vue&type=script&lang=js&"
import style0 from "./privacySDK.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports